import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

interface PrimaryButtonProps extends Omit<ButtonProps, "variant"> {
  variant: "contained" | "outlined";
  children: React.ReactNode;
  loading?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  variant,
  children,
  loading = false,
  disabled,
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      color="primary"
      disabled={loading || disabled}
      sx={{ position: "relative" }}
      {...rest}
    >
      {loading ? (
        <CircularProgress
          size={20}
          color="inherit"
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            marginLeft: "-10px",
            marginTop: "-10px",
          }}
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default PrimaryButton;
